export const SET_DOCUMENTS_FILTERS = 'SET_DOCUMENTS_FILTERS';
export const SET_DOCUMENTS_FILTERS_LOADING = 'SET_DOCUMENTS_FILTERS_LOADING';
export const SET_DOCUMENTS_CHOSEN_FILTER = 'SET_DOCUMENTS_CHOSEN_FILTER';
export const SET_DOCUMENTS_CHOSEN_FILTER_NAME = 'SET_DOCUMENTS_CHOSEN_FILTER_NAME';
export const SET_DOCUMENTS_FILTERS_ERROR = 'SET_DOCUMENTS_FILTERS_ERROR';